import React from 'react';

import { Icon, Props } from './icon';

export const CheckCircleOutlinedIcon: React.FC<Props> = (props: Props) => (
  <Icon {...props}>
    <path d="M12 24C5.372 24 0 18.628 0 12C0 5.372 5.372 0 12 0C18.628 0 24 5.372 24 12C24 18.628 18.628 24 12 24Z" />
    <path
      d="M18.5 7.5L11.7778 17L6.5 12.5"
      stroke="#F2F2F2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default CheckCircleOutlinedIcon;
